import { render, staticRenderFns } from "./dueForregularization.vue?vue&type=template&id=3d4d8336&scoped=true&"
import script from "./dueForregularization.vue?vue&type=script&lang=js&"
export * from "./dueForregularization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d8336",
  null
  
)

export default component.exports